import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Returned to Class/Break' },
    { value: 2, label: 'Sent to Medical Centre' },
    { value: 3, label: 'Sent to Hospital' },
    { value: 4, label: 'Caregiver Collected' },
  ],
});
